"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableLabelField = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const classnames_1 = __importDefault(require("classnames"));
const __1 = require("../");
const field_style_1 = __importDefault(require("./field.style"));
class EditableLabelField extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = {
            editMode: false
        };
        this.toggleEditMode = () => {
            this.setState({ editMode: !this.state.editMode });
        };
        this.onSubmit = value => {
            this.props.onSubmit(value);
            this.toggleEditMode();
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.value === undefined)
            return { value: props.value };
        return null;
    }
    renderToggle() {
        const { editMode } = this.state;
        const { classes, editable } = this.props;
        if (editable)
            return (jsx_runtime_1.jsx("button", Object.assign({ onClick: this.toggleEditMode, className: classes.edit }, { children: editMode ? 'Save' : 'Edit' }), void 0));
        return null;
    }
    renderValue() {
        const { onSubmit, toggleEditMode, props: { editable, label }, state: { value, editMode } } = this;
        if (!editable)
            return value;
        const placeholder = `Add ${label.toLowerCase()}`;
        return (jsx_runtime_1.jsx(__1.EditableText, Object.assign({}, { placeholder, editMode, value, onSubmit, toggleEditMode }), void 0));
    }
    render() {
        const { classes, label, valueClassName } = this.props;
        return (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.container }, { children: [jsx_runtime_1.jsx("div", Object.assign({ className: classes.label }, { children: label }), void 0),
                jsx_runtime_1.jsx("div", Object.assign({ className: classnames_1.default(classes.value, valueClassName) }, { children: this.renderValue() }), void 0),
                jsx_runtime_1.jsx("div", Object.assign({ className: classes.action }, { children: this.renderToggle() }), void 0)] }), void 0));
    }
}
exports.EditableLabelField = EditableLabelField;
EditableLabelField.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    label: prop_types_1.default.string.isRequired,
    onSubmit: prop_types_1.default.func,
    value: prop_types_1.default.string,
    editable: prop_types_1.default.bool,
    valueClassName: prop_types_1.default.string
};
EditableLabelField.defaultProps = {
    onSubmit: () => null,
    value: undefined,
    editable: false,
    valueClassName: null
};
exports.default = react_jss_1.default(field_style_1.default)(EditableLabelField);
//# sourceMappingURL=index.js.map